import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  animalDetailsModdal: {
    maxWidth: 'none',
    maxHeight: 'none',
    width: '840px',
    height: '100%',
    margin: 0,
    position: 'absolute',
    right: 0,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '100%',
      margin: 0,
      maxWidth: '100%',
      borderRadius: 0
    }
  },

  animalDetailsContainer: {
    [theme.breakpoints.down('sm')]: {
      zIndex: '1  !important'
    }
  },

  viewMainContainer: {
    padding: '8px 24px',

    [theme.breakpoints.down('sm')]: {
      padding: 16
    }
  },

  headerButtonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    cursor: 'pointer'
  },

  closeButtonIcon: {
    color: '#000',
    fontSize: 20,
    cursor: 'pointer'
  }
}))
